import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import React from 'react'

import { CMSState } from '../../../../cms/blocks/types.gen'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'
import { getRandomInt } from '../../../../../helpers'

export type IframeBlockProps = {
  link: string
  width?: number | string
  height?: number | string
}

export type IframeBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  content_classname: string
  iframe_classname: string
}>

export function IframeBlock<CustomBlockData, extra_images>(
  props: IframeBlockProps,
  options?: { style?: IframeBlockStyle; key?: string }
): (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: onDone => (
        <section
          className={getClassName(options, 'block_classname', '')}
          key={options && options.key ? options.key : `iframe-block-${props.link}`}
        >
          <div className={getClassName(options, 'inner_classname', '')}>
            <div className={getClassName(options, 'content_classname', '')}>
              <iframe
                className={getClassName(options, 'iframe_classname', '')}
                src={props.link}
                frameBorder={0}
                width={props.width ? props.width : '100%'}
                height={props.height ? props.height : 600}
              />
            </div>
          </div>
        </section>
      )
    })
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/iframeBlock.mod.tsx